import React from 'react';
import {
  notifyViewStartLoading,
  notifyViewFinishedLoading,
  getCurrentInstance,
  PageComponentId,
  hideSidebar,
  unhideSidebar,
  navigateTo,
  onNavigation,
} from '@wix/business-manager-api';
import { MENUS_APP_DEF_ID, ORDERS_APP_DEF_ID } from './utils/constants';
import App from './entry';
import { storeFactory } from './stateManagement/engine/createStore';
import { createBrowserHistory } from 'history';
import i18nFactory from './i18n';
import { create } from '@wix/fedops-logger';
import BILogger from './utils/BILogger';
import { getCashierApi } from './utils/cashierApi';

const fedopsLogger = create(PageComponentId.RestaurantsCallCenter);
const createStore = storeFactory();
const history = createBrowserHistory();

function reportSystemIsFullyLoaded({ organizationId }) {
  notifyViewFinishedLoading(PageComponentId.RestaurantsCallCenter);
  BILogger.loadCallCenter({ organizationId });
}

export default class AppContainer extends React.Component {
  constructor(props) {
    super(props);
    notifyViewStartLoading(PageComponentId.RestaurantsCallCenter);
    fedopsLogger.appLoaded();
  }

  render() {
    const instance = getCurrentInstance(MENUS_APP_DEF_ID);
    const fallbackInstance = getCurrentInstance(ORDERS_APP_DEF_ID);
    const { locale, metaSiteId: msid } = this.props;
    const i18n = i18nFactory(locale);
    const { localStorage } = window;
    const store = createStore(
      undefined,
      { msid, instance, fallbackInstance },
      {
        i18n,
        history,
        hideSidebar,
        unhideSidebar,
        reportSystemIsFullyLoaded,
        navigateTo,
        onNavigation,
        localStorage,
        getCashierApi,
      },
    );

    return <App store={store} i18n={i18n} />;
  }
}
